export default {
      id: "quiz-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "sprite.svg#quiz",
      toString: function () {
        return this.url;
      }
    }